import layout from '@/layout'

export default {
  path: '/pre_close_in',
  component: layout,
  redirect: '/pre_close_in/page6',
  name: 'pre_close_in_page6',
  meta: {
    title: 'pre_close_in',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_in/page6',
      name: 'pre_close_in_page6',
      component: () => import('@/views/pre_settle/pre_close/in/index6'),
      meta: {
        title: 'pre_close_in_page6',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
